import { Fragment } from "react";
import { Box, Divider } from "@mui/material";
import { IWikifolioKeyFigure } from "src/api/server/wf-detail.types";
import { Ranking } from "src/components-mui/common/ranking/ranking";

interface ITopKpiProps {
    keyFigures: IWikifolioKeyFigure[];
}

export const TopKpi = ({ keyFigures }: ITopKpiProps) => {
    return (
        <Box component="section" sx={{ display: "flex", justifyContent: "center" }}>
            <Box
                sx={{
                    display: "grid",
                    position: "relative",
                    gridTemplateColumns: { xs: "1fr 1fr", sm: "repeat(3, 1fr auto) 1fr", md: "repeat(4, 1fr auto) 1fr" },
                    rowGap: { xs: 4, sm: "unset" },
                    width: "100%",
                    justifyContent: { xs: "initial", sm: "center" },
                    zIndex: 1,
                }}
            >
                {keyFigures.map((keyFigure, index) => {
                    const isLast = index === keyFigures.length - 1;
                    return (
                        <Fragment key={index}>
                            <Ranking
                                sx={{ display: isLast ? { xs: "none", md: "flex" } : "flex" }}
                                size="xl"
                                data={keyFigure.ranking}
                                tooltip={keyFigure.tooltip}
                            />
                            <Divider orientation="vertical" flexItem sx={{ display: { xs: "none", sm: "block" }, borderColor: "gray.100" }} />
                        </Fragment>
                    );
                })}
                <Box sx={{ zIndex: -1, position: "absolute", height: "100%", width: "100%", display: { xs: "block", sm: "none" } }}>
                    <Divider orientation="horizontal" sx={{ borderColor: "gray.100", pt: 8 }} />
                    <Divider
                        orientation="vertical"
                        sx={{ position: "absolute", height: "100%", borderColor: "gray.100", top: 0, ml: "-1px", left: "50%" }}
                    />
                </Box>
            </Box>
        </Box>
    );
};
